import { SHOW_USER_FEEDBACK, CLEAR_USER_FEEDBACK } from '../actions/types'

const defaultState = { msg: '', type: '' }
const feedback = (state = defaultState, action) => {
  switch (action.type) {
    case SHOW_USER_FEEDBACK:
      return action.payload
    case CLEAR_USER_FEEDBACK:
      return defaultState
    default:
      return state
  }
}

export { feedback }
